import * as components from './components'

export default [
  {
    path: '/auth/login',
    component: components.Login,
    name: 'login'
  }
  // {
  //   path: '/auth/register',
  //   component: components.Register,
  //   name: 'register'
  // },
  // {
  //   path: '/auth/password_recovery',
  //   component: components.ForgotPassword,
  //   name: 'forgot_password'
  // },
  // {
  //   path: '/auth/registration_success',
  //   component: components.RegistrationSuccess,
  //   name: 'registration_success'
  // }
]
